/** Figma `5106:9975` — e.g. "Mar 30, 2026" in Recent Campaigns table. */
export function formatAdminDashboardCreatedDate(iso: string): string {
  const date = new Date(iso)
  if (!Number.isFinite(date.getTime())) return '—'
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
